import React, { useState, useContext, useEffect } from 'react';
import { useStyles, ContainerModal, ContainerSpecialties } from './styles';
import { Modal, Divider } from '@material-ui/core';
import { TopModal } from './components/TopModal';
import { ScalesCheckboxes } from './components/ScalesCheckboxes';
import { StatusCheckboxes } from './components/StatusCheckboxes';
import { BottomModal } from './components/BottomModal';
import { ExchangesPageContext } from 'page/exchangeReport/index';
import CustomSelectUnitScales from '../forms/CustomSelectUnitScales';

export default function FilterShiftsModal({
  currentContext = ExchangesPageContext,
  onlyOneScale = false,
  buttonFilter = false,
}) {
  const classes = useStyles();

  const {
    openFilter,
    setSelectedSchedule,
    mainFilter,
    selectedUnit,
    scaleInArray,
    findSelectedScale,
    handleCloseFilter = () => {},
    setMainFilter = () => {},
    userScales = null,
    setAutoSelectedScaleName = null,
  } = useContext(currentContext);

  const [cleanAll, setCleanAll] = useState(false);
  const [specialty, setSpecialty] = useState([]); // Initialize as array for multi-select

  const handleCleanAll = () => {
    setCleanAll(true);
    setSpecialty([]); // Clear specialty for multi-select
    setMainFilter((old) => ({ ...old, scales: [], custom_filter: [] }));
    setTimeout(() => {
      setCleanAll(false);
    }, 200);
  };

  useEffect(() => {
    if (onlyOneScale && mainFilter?.scales?.length > 0) {
      // For multi-select, set specialty as an array of objects
      setSpecialty(
        mainFilter.scales.map((scale) => ({
          value: scale.id || scale.value,
          label: scale.name || scale.label,
        }))
      );
    } else if (findSelectedScale && findSelectedScale !== undefined) {
      // Handle single scale from findSelectedScale
      setSpecialty([
        {
          value: findSelectedScale.value,
          label: findSelectedScale.label,
        },
      ]);
    } else if (mainFilter?.scale_id) {
      // Handle single scale from mainFilter
      setSpecialty([
        {
          value: mainFilter.scale_id,
          label: mainFilter.scale_name,
        },
      ]);
    } else {
      setSpecialty([]); // Ensure empty array when no scales are selected
    }

    return () => {
      setSpecialty([]);
    };
  }, [mainFilter, findSelectedScale, onlyOneScale]);

  useEffect(() => {
    // Sincroniza o specialty com o scaleInArray
    if (scaleInArray && scaleInArray.length > 0) {
      setSpecialty(
        scaleInArray.map((item) => ({
          value: item.value,
          label: item.label,
        }))
      );
    } else {
      setSpecialty([]); // Garante que specialty esteja vazio se não houver chips
    }
  }, [scaleInArray]);

  const changeLocalScales = (data) => {
    if (!data || data.length === 0) {
      scaleInArray.length = 0; // Clear scaleInArray if data is empty
      localStorage.setItem('selectedScale', JSON.stringify([]));
      return;
    }

    // Handle multi-select: update scaleInArray with all selected scales
    const newScales = data.map((item) => ({
      ...item,
      label: item.labelSelected ?? item.label,
      unit: selectedUnit.id,
    }));

    // Clear and update scaleInArray
    scaleInArray.length = 0;
    scaleInArray.push(...newScales);
    localStorage.setItem('selectedScale', JSON.stringify(scaleInArray));
  };

  return (
    <Modal
      open={openFilter}
      onClose={handleCloseFilter}
      disableAutoFocus
      disableEnforceFocus
    >
      <ContainerModal className={classes.paper}>
        {onlyOneScale && (
          <ContainerSpecialties id="modalEscala">
            <div className={classes.label}> Filtrar por Escala</div>
            <CustomSelectUnitScales
              name="escales.id"
              placeholder="Escalas"
              id="Escalas"
              menuList={() => ({ height: 116, overflowY: 'auto' })}
              handleChange={(data) => {
                setSpecialty(data || []); // Update specialty as array
                setSelectedSchedule && setSelectedSchedule('');
                setAutoSelectedScaleName && setAutoSelectedScaleName(null);
                changeLocalScales(data || []); // Update local storage
                const selectedScales = (data || []).map((item) => ({
                  id: item.value,
                  name: item.labelSelected ?? item.label,
                }));
                const firstScale = selectedScales[0];
                setMainFilter((old) => ({
                  ...old,
                  scales: selectedScales,
                  scale_id: firstScale?.id ?? null,
                  scale_name: firstScale?.name ?? null,
                }));
              }}
              value={specialty}
              unit_id={mainFilter?.unit_id}
              scopedScales={userScales}
              showCount={!userScales}
              isClearable
              isMulti
            />
          </ContainerSpecialties>
        )}
        {!onlyOneScale && (
          <div className={classes.groupTopModal}>
            <TopModal />
            <div className={classes.containerCheckbox}>
              <ScalesCheckboxes
                cleanAll={cleanAll}
                currentContext={currentContext}
              />
              <Divider
                orientation="vertical"
                style={{
                  height: 200,
                  width: 1,
                  marginTop: 45,
                }}
              />
              <StatusCheckboxes
                cleanAll={cleanAll}
                currentContext={currentContext}
              />
            </div>
          </div>
        )}

        <BottomModal
          handleCloseFilter={handleCloseFilter}
          handleCleanAll={handleCleanAll}
          onlyOneScale={onlyOneScale}
          buttonFilter={buttonFilter}
        />
      </ContainerModal>
    </Modal>
  );
}
